import { NgModule } from '@angular/core';
import { CoreComponent } from './core.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CoreRoutingModule } from './core-routing.module';
import { LayoutModule } from './layout/layout.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { DashboardService } from './services/dashboard.service';
import { LayoutService } from './services/layout.service';
import { CompanyService } from './services/company.service';
import {
	DropdownModule,
	FieldsetModule,
	MessageModule,
	MessagesModule,
	PanelModule,
	ToolbarModule
} from 'primeng/primeng';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SharedModule } from '../shared/shared.module';
import { EmailTemplateService } from './services/email-templates.service';
import { PermissionService } from './services/permission.service';
import { RoleService } from './services/role.service';
import { UserService } from './services/users.service';

@NgModule({
	imports: [
		CommonModule,
		ProgressSpinnerModule,
		TableModule,
		ProgressBarModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		DropdownModule,
		ToolbarModule,
		PanelModule,
		FieldsetModule,
		MessagesModule,
		MessageModule,
		LayoutModule,
		CoreRoutingModule,
		SharedModule
	],
	declarations: [ CoreComponent, DashboardComponent, ChangePasswordComponent ],
	exports: [],
	providers: [ LayoutService, DashboardService, EmailTemplateService, PermissionService, RoleService, UserService, CompanyService ]
})
export class CoreModule {}
